import{jsxs as e,jsx as r}from"react/jsx-runtime";import{useState as a,useEffect as o}from"react";import n from"tailwind-styled-components";import l from"clsx";const t=n.div`
  overflow-hidden
  relative
  rounded-full
  shadow-inner
  transition-colors
`,i=n.input`
  absolute
  appearance-none
  cursor-pointer
  left-0
  h-full
  top-0
  w-full
`,c=n.span`
  bg-white
  block
  h-[calc(100%_-_2px)]
  pointer-events-none
  rounded-full
  transition-all
  mt-[1px]
  mx-[1px]

  dark:bg-gray-200
`,s=({checked:n,className:s,onChange:m,size:p="normal",...d})=>{const[h,g]=a(!!n),[u,w]=a(!1),f=l(s,{"bg-black/20 dark:bg-gray-600/50":!h,"bg-brand-primary dark:bg-brand-primary-light":h,"h-4 w-8":"small"===p,"h-6 w-12":"normal"===p,"h-7 w-14":"large"===p,"h-9 w-[4.5rem]":"xlarge"===p}),b=l({"translate-x-[calc(100%_-_2px)] origin-right":h,"origin-left":!h,"scale-x-125":u,"w-4":"small"===p,"w-6":"normal"===p,"w-7":"large"===p,"w-9":"xlarge"===p});return o((()=>{g(!!n)}),[n]),e(t,{className:f,children:[r(i,{...d,checked:h,onChange:e=>{const r=e.target.checked;"boolean"!=typeof n&&g(r),"function"==typeof m&&m(r)},onMouseDown:()=>w(!0),onMouseUp:()=>w(!1),onMouseLeave:()=>w(!1),role:"switch",type:"checkbox"}),r(c,{className:b})]})};s.displayName="Switch";export{s as Switch,s as default};
